module.exports = __webpack_public_path__ + "img/avatar.ecba1844.gif";